export default __webpack_public_path__ + "static/media/box_2.deed9d0b.png";